(function () {
  const hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const storeMenus = new Map();

  const bindStoreMenus = (root = document) => {
    root.querySelectorAll('.header-store').forEach((store) => {
      if (store.dataset.bound === 'true') return;

      const button = store.querySelector('.header-store__button');
      const overlay = store.querySelector('.header-store__overlay');
      const dialog = store.querySelector('.header-store__dialog');
      const closeButton = store.querySelector('[data-header-store-close]');
      if (!button || !overlay || !dialog) return;
      store.dataset.bound = 'true';

      const menuLabel = dialog.getAttribute('aria-label');
      const slot = document.createComment('header-store-overlay');
      overlay.before(slot);
      const listeners = [];
      const listen = (target, type, handler) => {
        target.addEventListener(type, handler);
        listeners.push(() => target.removeEventListener(type, handler));
      };
      let mobileOpen = false;
      let ownsBodyLock = false;

      const setOpen = (open, restoreFocus = true) => {
        const isMobile = mobileQuery.matches;
        const alreadyOpen = store.classList.contains('is-open') || overlay.classList.contains('is-open');
        if (!open && !alreadyOpen) return;

        store.classList.toggle('is-open', open);
        overlay.classList.toggle('is-open', open);
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
        overlay.setAttribute('aria-hidden', open ? 'false' : 'true');

        if (isMobile && open) {
          document.body.append(overlay);
          if (!mobileOpen) ownsBodyLock = !document.body.classList.contains('overflow-hidden');
          mobileOpen = true;
          document.body.classList.add('overflow-hidden');
          dialog.setAttribute('role', 'dialog');
          dialog.setAttribute('aria-modal', 'true');
          dialog.setAttribute('aria-labelledby', 'HeaderStoreTitle');
          dialog.removeAttribute('aria-label');
          if (typeof trapFocus === 'function') {
            trapFocus(dialog, closeButton || dialog);
          } else if (closeButton) {
            closeButton.focus();
          }
          return;
        }

        if (mobileOpen) {
          if (typeof removeTrapFocus === 'function') {
            removeTrapFocus(restoreFocus ? button : null);
          } else if (restoreFocus) {
            button.focus({ preventScroll: true });
          }
        }

        if (ownsBodyLock) document.body.classList.remove('overflow-hidden');
        mobileOpen = false;
        ownsBodyLock = false;
        dialog.setAttribute('role', 'menu');
        dialog.removeAttribute('aria-modal');
        dialog.removeAttribute('aria-labelledby');
        if (menuLabel) dialog.setAttribute('aria-label', menuLabel);
        if (slot.parentNode) slot.after(overlay);
      };

      listen(button, 'click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (!mobileQuery.matches && hoverQuery.matches) return;
        setOpen(!store.classList.contains('is-open'));
      });

      listen(overlay, 'click', (event) => {
        if (event.target === overlay) setOpen(false);
      });

      if (closeButton) {
        listen(closeButton, 'click', (event) => {
          event.preventDefault();
          setOpen(false);
        });
      }

      overlay.querySelectorAll('.header-store__link').forEach((link) => {
        listen(link, 'click', () => {
          if (mobileQuery.matches) setOpen(false);
        });
      });

      listen(document, 'click', (event) => {
        if (mobileQuery.matches) return;
        if (!store.contains(event.target)) setOpen(false);
      });

      listen(document, 'keyup', (event) => {
        if (event.key === 'Escape') setOpen(false);
      });

      const onViewportChange = () => setOpen(false);
      if (typeof mobileQuery.addEventListener === 'function') {
        mobileQuery.addEventListener('change', onViewportChange);
      } else if (typeof mobileQuery.addListener === 'function') {
        mobileQuery.addListener(onViewportChange);
      }

      storeMenus.set(store, () => {
        setOpen(false, false);
        listeners.forEach((removeListener) => removeListener());
        if (typeof mobileQuery.removeEventListener === 'function') {
          mobileQuery.removeEventListener('change', onViewportChange);
        } else if (typeof mobileQuery.removeListener === 'function') {
          mobileQuery.removeListener(onViewportChange);
        }
        slot.remove();
        delete store.dataset.bound;
        storeMenus.delete(store);
      });
    });
  };

  document.addEventListener('shopify:section:load', (event) => {
    storeMenus.forEach((cleanup, store) => {
      if (!store.isConnected) cleanup();
    });
    bindStoreMenus(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    storeMenus.forEach((cleanup, store) => {
      if (event.target.contains(store)) cleanup();
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => bindStoreMenus());
  } else {
    bindStoreMenus();
  }
})();
